export class DocumentItem {
    id: number;
    created_on: string;
    document_path: string;
    created_on_date: string;
    created_on_time: string;
    athlete_document_status_id_fk: number;
    athlete_document_status_label: string;
    athlete_document_type_id_fk: number;
    athlete_document_type_label: string;
    status_label: string;
    type_label: string;
    pdf_link: string;

    constructor() { }


}


// WEBPACK FOOTER //
// ./src/app/_models/documentItem.model.ts